import Button from "./Button";

interface StartOverButtonProps {
  startOver: () => void;
}

const StartOverButton = (props: StartOverButtonProps) => {
  return (
    <div>
      <div className="position-relative">
        <div className="position-absolute top-0">
          <Button className="m-2" onClick={props.startOver}>
            Start Over <i className="bi-arrow-counterclockwise"></i>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default StartOverButton;